import { render, staticRenderFns } from "./identityAuth.vue?vue&type=template&id=654b5fe6&scoped=true"
import script from "./identityAuth.vue?vue&type=script&lang=js"
export * from "./identityAuth.vue?vue&type=script&lang=js"
import style0 from "./identityAuth.vue?vue&type=style&index=0&id=654b5fe6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b5fe6",
  null
  
)

export default component.exports